<template>
    <div class="p-grid crud-demo">
        <h1 class="p-mx-auto">Academic Qualifications</h1>
        <div class="p-col-12">
            <Toast/>
            <AcademicDataTable :academics="academics"
                               :paginator="true"
                               :filter="true"
                               :admin-mode="true"
                               :showStaff="true"
                               :loading="loading"
                               @create-academic="createAcademic"
                               @edit-academic="editAcademic"
                               @confirm-delete-academic="confirmDeleteAcademic"
                               @confirm-delete-selected-academics="confirmDeleteSelectedAcademics"
                               @toggle-academics="toggleAcademics"
                               @show-file-dialog="showFileDialog"/>

            <AcademicDialog ref="academicDialog" @updated="onItemsUpdated"/>
            <FileDialog ref="fileDialog" @updated="onItemsUpdated"/>
        </div>
    </div>
</template>

<script>
import {Component, Vue} from 'vue-property-decorator'
import Toast from 'primevue/toast';
import AcademicService from "@/service/AcademicService";
import AcademicDialog from "../components/dialog/AcademicDialog";
import AcademicDataTable from '../components/datatable/AcademicDataTable'
import FileDialog from "../components/dialog/FileDialog";
import store from "../store";

/**
 * Class-component
 */
@Component({
    components: {
        AcademicDialog,
        AcademicDataTable,
        FileDialog,
        Toast: Vue.extend(Toast),
    }
})
export default class Academics extends Vue {
    academicService = new AcademicService();
    academics = [];
    academicDialog = false;
    loading = false;
    toastSuccess = {
        severity: 'success',
        summary: 'Successful',
        detail: '',
        life: 3000
    };
    toastError = {
        severity: 'error',
        summary: 'Error',
        detail: '',
        life: 3000
    };

    async mounted() {
        try {
            this.loading = true;
            this.academics = await this.academicService.getAcademics();
            this.loading = false;
        } catch (e) {
            this.toastError.detail = e.message
            this.toastError.life = null
            this.$toast.add(this.toastError);
            this.academicService.logError(e).forEach(err => {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Details',
                    detail: err,
                    life: null
                });
            })
        }
    }

    // listen to items updated
    async onItemsUpdated() {
        this.academics = await this.academicService.getAcademics();
    }

    // Academic Dialog
    createAcademic() {
        this.$refs.academicDialog.createAcademic = true;
        this.$refs.academicDialog.academic = {};
        this.$refs.academicDialog.academicDialog = true;
    }

    async editAcademic(academic) {
        this.$refs.academicDialog.createAcademic = false;
        this.$refs.academicDialog.academic = {...academic};
        this.$refs.academicDialog.academicDialog = true;
    }

    confirmDeleteAcademic(academic) {
        this.$refs.academicDialog.academic = academic;
        this.$refs.academicDialog.deleteAcademicDialog = true;
    }

    confirmDeleteSelectedAcademics(selectedAcademics) {
        this.$refs.academicDialog.selectedAcademics = selectedAcademics;
        this.$refs.academicDialog.deleteAcademicsDialog = true;
    }

    toggleAcademics(selectedAcademics, status) {
        this.$refs.academicDialog.selectedAcademics = selectedAcademics;
        this.$refs.academicDialog.verifyAcademics = status;
        this.$refs.academicDialog.toggleAcademicsDialog = true;
    }

    // File Dialog
    async showFileDialog(record) {
        try {
            this.loading = true;
            record = await store.dispatch('jv/get', [`${record._jv.type}/${record._jv.id}`, {params: {include: 'files', 'fields[files]': 'name,created-at'}}]);
            this.$refs.fileDialog.record = record;
            this.$refs.fileDialog.files = Object.values(record.files);
            this.$refs.fileDialog.fileDialog = true;
            this.loading = false;
        } catch (e) {
            this.toastError.detail = e.message
            this.toastError.life = null
            this.$toast.add(this.toastError);
            this.staffService.logError(e).forEach(err => {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Details',
                    detail: err,
                    life: null
                });
            })
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
